// src/emailService.js
const API_URL = process.env.REACT_APP_API_URL || 'https://devis.takoussane.com/api';

const buildCc = (extraCc) => {
  const base = 'contact@takoussane.com';
  const extras = (extraCc || []).filter(e => e && e !== base);
  return [base, ...extras];
};

export const sendQuoteEmail = async ({ to, cc, from_name, from_email, subject, body, pdfBase64, quoteNumber }) => {
  if (!from_email || from_email === 'contact@takoussane.com') {
    console.error('[emailService] BLOCAGE : from_email manquant ou fallback detecte. Profil non charge.');
    return { success: false, error: "Votre profil n'est pas charge correctement. Rafraichissez la page ou contactez le support avant d'envoyer un devis." };
  }
  try {
    const response = await fetch(`${API_URL}/send-quote`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        to,
        cc: buildCc(cc),
        from_name,
        from_email,
        subject,
        body,
        pdfBase64,
        quoteNumber,
      }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Erreur envoi email');
    return { success: true, id: data.id };
  } catch (e) {
    console.error('sendQuoteEmail:', e);
    return { success: false, error: e.message };
  }
};

export const sendReminderEmail = async ({ to, cc, from_name, from_email, client_name, quote_number, message, total, fonction, mobile }) => {
  if (!from_email || from_email === 'contact@takoussane.com') {
    console.error('[emailService] BLOCAGE : from_email manquant ou fallback detecte. Profil non charge.');
    return { success: false, error: "Votre profil n'est pas charge correctement. Rafraichissez la page ou contactez le support avant d'envoyer un devis." };
  }
  try {
    const response = await fetch(`${API_URL}/send-reminder`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        to,
        cc: cc && cc.length ? cc : buildCc([]),
        from_name,
        from_email,
        client_name,
        quote_number,
        message,
        total,
        fonction,
        mobile,
      }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Erreur envoi relance');
    return { success: true, id: data.id };
  } catch (e) {
    console.error('sendReminderEmail:', e);
    return { success: false, error: e.message };
  }
};